import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const DateFilterModal = ({ isOpen, onClose, timeRange, setTimeRange, selectedPage, onApply, isDashboardPage = true }) => {
  if (!isOpen) return null;

  const timeRangeOptions = [
    { value: 1, label: 'Yesterday', icon: 'clock' },
    { value: 7, label: '7 Days', icon: 'calendar-week' },
    { value: 30, label: '30 Days', icon: 'calendar-alt' },
    { value: 90, label: '90 Days', icon: 'calendar' }
  ];

  // Check if "All Pages" is selected (overall) AND we're on a Dashboard page
  const isAllPages = selectedPage === 'overall';
  const shouldRestrictDates = isAllPages && isDashboardPage;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.filtersModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>
            <FontAwesomeIcon icon="calendar" />
            Date Range Filter
          </h3>
          <button className={styles.modalCloseBtn} onClick={onClose}>
            <FontAwesomeIcon icon="times" />
          </button>
        </div>
        
        <div className={styles.modalContent}>
          {shouldRestrictDates && (
            <div className={styles.allPagesNotice}>
              <FontAwesomeIcon icon="info-circle" />
              <span>All Pages view is limited to Yesterday data only</span>
            </div>
          )}
          <div className={styles.timeRangeGrid}>
            {timeRangeOptions.map(option => {
              const isDisabled = shouldRestrictDates && option.value !== 1;
              const isSelected = timeRange === option.value;
              
              return (
                <div
                  key={option.value}
                  className={`${styles.timeRangeCard} ${isSelected ? styles.selected : ''} ${isDisabled ? styles.disabled : ''}`}
                  onClick={() => !isDisabled && setTimeRange(option.value)}
                  tabIndex={isDisabled ? -1 : 0}
                  onKeyDown={e => { if (e.key === 'Enter' && !isDisabled) setTimeRange(option.value); }}
                  role="button"
                  aria-pressed={isSelected}
                  aria-disabled={isDisabled}
                >
                  <div className={styles.timeRangeIcon}>
                    <FontAwesomeIcon icon={option.icon} />
                  </div>
                  <div className={styles.timeRangeLabel}>{option.label}</div>
                  {isDisabled && (
                    <div className={styles.disabledOverlay}>
                      <FontAwesomeIcon icon="lock" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.modalActions}>
          <button className={styles.applyBtn} onClick={onApply}>
            Apply Filter
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateFilterModal; 